import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { TrainDataService } from '../../../trains/services/train-data.service';
import { Train } from '../../../trains/models/train';
import {Observable, of, combineLatest, Subscription} from 'rxjs';
import { StateService } from '@uirouter/core';
import { map, switchMap, take } from 'rxjs/operators';
import { QueryWordsDataService } from '../../services/query-words-data.service';
import { ParseUrlDateStringToDatePipe } from '../../../../shared/pipes/parse-url-date-string-to-date.pipe';
import { ReportingDataService } from '../../services/reporting-data.service';
import { DatePipe } from '@angular/common';
import { TripSlas } from '../../models/tripSlas';
import { DbKeyValueDecimal } from '../../models/dbKeyValueDecimal';
import { TelecomOperator } from '../../models/telecomOperator';

import { TripDashboardDataService } from '../../services/trip-dashboard-data.service';
import { TrainsSelectorFormComponent } from '../../components/trains-selector-form/trains-selector-form.component';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ProjectConfiguration } from "../../../project/models/project-configuration";
import { ProjectConfigurationBehaviorSubjectService } from "../../../project/services/project-configuration-behavior-subject.service";
@Component({
  selector: 'app-trip-dashboard',
  template: require('./trip-dashboard.component.html'),
  styles: [require('./trip-dashboard.component.sass')]
})
export class TripDashboardComponent implements OnInit {

  @ViewChild(TrainsSelectorFormComponent) trainsSelectorForm: TrainsSelectorFormComponent;

  projectId: number;
  trains$: Observable<Train[]>;
  trainTypes$: Observable<string[]>;
  maintainers$: Observable<string[]>;
  tripIds$: Observable<number[] | null>;
  tripSlas$: Observable<TripSlas | null>;
  operators$: Observable<TelecomOperator[]>;

  operatorConsumptions$: Observable<DbKeyValueDecimal[] | null>;
  exceededUsers$: Observable<DbKeyValueDecimal[] | null>;
  spreadUsers$: Observable<DbKeyValueDecimal[] | null>;
  classAvgConsumptions$: Observable<DbKeyValueDecimal[] | null>;
  operatorDailyTotalConsumptions$: Observable<DbKeyValueDecimal[] | null>;
  operatorDailyPercentageConsumptions$: Observable<DbKeyValueDecimal[] | null>;
  modemSpectrumBandUsages$: Observable<DbKeyValueDecimal[] | null>;
  dailyTotalUserSpreads$: Observable<DbKeyValueDecimal[] | null>;
  dailyPercentageUserSpreads$: Observable<DbKeyValueDecimal[] | null>;
  classTotalConsumptions$: Observable<DbKeyValueDecimal[] | null>;
  dailyQoEs$: Observable<DbKeyValueDecimal[] | null>;

  query: string; 
  from: Date | undefined; 
  to: Date | undefined; 
  trainIds: number[];
  main: boolean; // TODO what is it for?
  goodtrips: boolean;
  projectConfigurationSubscription: Subscription;
  projectConfiguration: ProjectConfiguration;
  words: any;
  isQueryValid: boolean;
  showHideSchedulingErrorsCheckbox: boolean;

  
  constructor(
      @Inject ( 'ConfigurationStoreService' ) private configurationStoreService: any,
    private $state: StateService,
    private trainDataService: TrainDataService,
    private queryWordsDataService: QueryWordsDataService, 
    private parseUrlDateStringToDatePipe: ParseUrlDateStringToDatePipe,
    private projectConfigurationBehaviorSubjectService: ProjectConfigurationBehaviorSubjectService,
    private reportingDataService: ReportingDataService,
    private datePipe: DatePipe,
    private tripDashboardDataService: TripDashboardDataService,
    private translate: TranslateService,
    private messageService: MessageService
  ) {
    this.projectConfigurationSubscription = this.projectConfigurationBehaviorSubjectService.changeOccured.subscribe(() => {
      this.projectConfiguration = this.configurationStoreService.getProjectConfiguration(this.projectId);
      this.showHideSchedulingErrorsCheckbox = this.projectConfiguration && this.projectConfiguration.showHideSchedulingErrorsCheckbox;
    });
  }

  ngOnInit() {
    this.projectId = this.$state.params && this.$state.params.projectId;
    this.query = this.$state.params && this.$state.params.query;
    this.from = this.$state.params && this.$state.params.from  && this.parseUrlDateStringToDatePipe.transform(this.$state.params.from);
    this.to = this.$state.params && this.$state.params.to  && this.parseUrlDateStringToDatePipe.transform(this.$state.params.to);
    this.trainIds = this.$state.params && this.$state.params.trainIds && this.$state.params.trainIds.split(",");
    this.goodtrips = this.$state.params && (this.$state.params.goodtrips === "true" || (this.$state.params.goodtrips === null));
    this.trains$ = this.trainDataService.getTrainslist(this.projectId);
    this.trainTypes$ = this.trains$.pipe(map(trains => {
      return [...new Set(trains.map(train => {
          return train.displayTypeName || train.trainType;
      }))]

    }));
    this.maintainers$ = this.trains$.pipe(map(trains => [...new Set(trains.map(train => train.maintainer))]));
    this.tripIds$ = this.trainIds ? this.reportingDataService.getDashboardTrips(this.projectId, JSON.parse(JSON.stringify({
            trainIds: this.trainIds.reduce<string>((acc, id) => acc ? acc + "," + id.toString() : id.toString(), ''),
            from: this.from && this.datePipe.transform(this.from, "yyyy-MM-dd'T'HH:mm:ssZ"),
            to: this.to && this.datePipe.transform(this.to, "yyyy-MM-dd'T'HH:mm:ssZ"),
            query: this.goodtrips ? (this.query ? this.query.concat(" AND LATENCY > -1") : "LATENCY > -1") : this.query,
            type: 'main'
          }))) : of(null);

    this.tripSlas$ = this.tripIds$.pipe(switchMap(tripIds => {
      return (tripIds && tripIds.length > 0) ? this.reportingDataService.getTripSlas(this.projectId, tripIds) : of(null)
    }));
    this.queryWordsDataService.getWords(this.projectId).then(words => {
      this.words = words
    })
    this.operators$ = this.reportingDataService.getOperators();
    this.operatorConsumptions$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'consumption/operator') : of(null)));
    this.exceededUsers$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'users/exceeded') : of(null)));
    this.spreadUsers$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'users/spread') : of(null)));
    this.classAvgConsumptions$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'consumption/avg/class') : of(null)));
    this.operatorDailyTotalConsumptions$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/total/consumption/operator') : of(null)));
    this.operatorDailyPercentageConsumptions$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/percentage/consumption/operator') : of(null)));
    this.modemSpectrumBandUsages$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'spectrum-band-usage-per-modem') : of(null)));
    this.dailyTotalUserSpreads$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/total/users/spread') : of(null)));
    this.dailyPercentageUserSpreads$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/percentage/users/spread') : of(null)));
    this.classTotalConsumptions$ = this.tripIds$.pipe(switchMap(tripIds => tripIds ? this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'total/consumption/class') : of(null)));
    this.dailyQoEs$ =  this.tripIds$.pipe(switchMap(tripIds => tripIds ?  combineLatest([
      this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/qoe/avg/users/tput'),
      this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/qoe/percentile/users/tput'),
      this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/qoe/percentile/vu/time'),
      this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/qoe/avg/vu/time'),
      this.reportingDataService.getTripDashboardStats(this.projectId, tripIds, 'daily/qoe/avg/latency'),
    ]).pipe(map(results => results.reduce((acc, dailyQoE) => [...acc, ...dailyQoE], []))) : of(null)));
  }


  onSubmitRequest = (data: {
    trains: Train[],
    from: number,
    to: number,
    hideSchedulingErrors: boolean
  }) => {
   this.$state.go('trip-dashboard', {
     projectId:  this.projectId,
     from: data.from,
     to: data.to, //,
     trainIds: data.trains.reduce<string>((acc, train) => acc ? acc + (train.id ? ("," + train.id.toString()) : '') : (train.id ? train.id.toString() : ''), ''),
     goodtrips: data.hideSchedulingErrors,
     query: this.query
   }, {reload: true})
  }

  exportToCsv = async() => {

    try {
      const tripStats = await this.reportingDataService.exportTrips(this.projectId, JSON.parse(JSON.stringify({
        trainIds: this.trainIds && this.trainIds.reduce<string>((acc, id) => acc ? acc + "," + id.toString() : id.toString(), ''),
        from: this.from && this.datePipe.transform(this.from, "yyyy-MM-dd'T'HH:mm:ssZ"),
        to: this.to && this.datePipe.transform(this.to, "yyyy-MM-dd'T'HH:mm:ssZ"),
        query: this.goodtrips ? (this.query ? this.query.concat("LATENCY > -1") : "LATENCY > -1") : this.query,
        type: 'main'
      }))) 

      this.tripDashboardDataService.exportTrips(tripStats, this.from, this.to);

    } catch (error) {
      if (this.trainIds) {
        this.messageService.add({
          severity:'error',
          summary: this.translate.instant("I18N_DASHBOARD.UNKNOWN_SERVER_ERROR_FOR_EXPORT_SUMMARY"),
          detail: error
        });
      } else {
        this.messageService.add({
          severity:'error',
          summary: this.translate.instant("I18N_DASHBOARD.NO_SELECTED_TRAINS_FOR_EXPORT_ERROR"),
          detail: this.translate.instant("I18N_DASHBOARD.NO_SELECTED_TRAINS_FOR_EXPORT_DESCRIPTION")
        });
      }
    }

  }

  onExecuteQuery = () => {
    this.trainsSelectorForm.onSubmit();
  }

}
